import { FC } from 'react';

import InfoTooltipIcon from './IconsSvg/InfoTooltipIcon';
import WarningTooltipIcon from './IconsSvg/WarningTooltipIcon';

interface Props {
    icon: 'info' | 'warning';
    children: React.ReactNode;
}

const ToolTipComponent: FC<Props> = ({ icon, children }) => {
    return (
        <div className="br-tooltip">
            {icon == 'warning' ? <WarningTooltipIcon /> : <InfoTooltipIcon />}
            <div className="tooltip-content">{children}</div>
        </div>
    );
};

export default ToolTipComponent;
